import normal from '@primer/primitives/dist/json/typography/normal.json'
export default {normal}
